import { AdElementText, DateTimeFormat } from '@adflow/types';
import { FormLabel, Input, Switch, HStack, Heading } from '@chakra-ui/react';
import { FC, useCallback } from 'react';
import { useStore } from '../../../../hooks/useStore';

type Props = {
  textElement: AdElementText;
};

export const isCountdownPresent = (textElement: AdElementText) => {
  if (!textElement.sources[0]) return false;
  return (
    textElement.data.content.includes(`${textElement.sources[0].sourceId}:COUNTDOWN}`) ||
    textElement.data.content.includes(`${textElement.sources[0].sourceId}:PRE_COUNTDOWN}`)
  );
};

const CountdownFormatControls: FC<Props> = ({ textElement }) => {
  const s = useStore((state) => ({
    displayOptions: state.displayOptions,
    setElementDateDisplayOptions: state.setElementDateDisplayOptions,
  }));

  const dateDisplayOptions: DateTimeFormat | null | undefined =
    textElement.data.dateDisplayOptions || s.displayOptions.dateTimeFormat;

  const handleUpdateDaysSeparator = useCallback(
    (value: string) => {
      let showDays = dateDisplayOptions?.countdownDaysSeparator || 'd';

      if (!value && value) return;
      showDays = value;
      s.setElementDateDisplayOptions(textElement.id, {
        ...dateDisplayOptions,
        countdownDaysSeparator: showDays,
      });
    },
    [s, dateDisplayOptions, textElement.id],
  );

  const handleUpdateShowDays = useCallback(
    (isEnabled: boolean) => {
      s.setElementDateDisplayOptions(textElement.id, {
        ...dateDisplayOptions,
        countdownShowDays: isEnabled,
      });
    },
    [s, dateDisplayOptions, textElement.id],
  );

  return (
    <>
      <Heading fontSize="lg" fontWeight="semibold" mt="2" noOfLines={1}>
        Countdown Format
      </Heading>
      <HStack spacing="48px" mt={'2'}>
        <HStack mb={'0'} direction="row" alignItems="center">
          <FormLabel fontWeight={'semibold'} mb={'0'}>
            Show days?
          </FormLabel>
          <Switch
            isChecked={dateDisplayOptions?.countdownShowDays || false}
            onChange={(evt) => handleUpdateShowDays(evt.target.checked)}
          />
        </HStack>
        <HStack spacing="0" direction="row" alignItems="center">
          <FormLabel fontWeight={'semibold'} mb={'0'}>
            Separator
          </FormLabel>

          <Input
            value={dateDisplayOptions?.countdownDaysSeparator || 'days'}
            id="countdown-days-separator"
            onChange={(e) => handleUpdateDaysSeparator(e.target.value)}
            placeholder="days"
          />
        </HStack>
      </HStack>
    </>
  );
};

CountdownFormatControls.displayName = 'TimeFormatControls';

export default CountdownFormatControls;
